export default "/Frontend/dist/image.21f131299651c41f8c6e6e3a331efcbc.svg";